// Import dependencies
import React from 'react';
import axios from 'axios';
import queryString from 'query-string';
import cookie from 'js-cookie';
import { tokenize } from '../../../../helper';
import { displayUserAuthAuthorized, displayEmailVerified, displayAffiliateNumber, displayDeviceType } from '../uiAdminHelpers';
import { FaUserCircle, FaStar } from 'react-icons/fa'

import AdminNavbar from '../../../reusables/adminNavbar';
import './MemberDetailPage.css';

// Import config
import config from '../../../../configs/config.json';
const API_URL = config.API_URL;
const ADMIN_API_URL = API_URL + '/admin';
const SETTINGS_URL = ADMIN_API_URL + '/settings';

class MemberDetailPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            memberID: 0,
            memberInfo: {},
            loginHistory: [],
            videoHistory: [],
        }
    }

    componentDidMount() {
        // As the component mounts, check if a token is already stored in the cookie
        var token = cookie.get('token');
        var user_type = cookie.get('user-type');
        if (token) {
            if (user_type === 'admin') {
                // Authorized as admin
            } else {
                // Not authorized as admin, re-direct to log in page
                window.location.href = '/admin/';
            }
        } else {
            // No token found, re-direct to log in page
            window.location.href = '/admin/'
        }

        var { id } = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true });


        if (!id) {
            window.location.href = '/admin/members'
        } else {
            // console.log("ID: ", id)
            this.setState({ memberID: id })
            setTimeout(this.queryMemberDetails, 100);
            setTimeout(this.queryVideoDetails, 100);
        }
    }

    queryMemberDetails = () => {
        axios.get(`${ADMIN_API_URL}/members/details?id=${this.state.memberID}`, tokenize())
            .then(response => {
                var payload = response.data;
                console.log(payload);

                if (payload.success) {
                    var { memberInfo, loginHistory } = payload;
                    this.setState({ memberInfo, loginHistory });
                } else {

                }
            })
            .catch(error => {

            })
    }


    queryVideoDetails = () => {
        axios.get(`${SETTINGS_URL}/analytics/videos?memberId=${this.state.memberID}`, tokenize())
            .then(response => {
                var payload = response.data;
                console.log(payload);

                if (payload.success) {
                    this.setState({ videoHistory: payload.newResult })
                }
            })
            .catch(error => {

            })
    }

    truncate = (input) => input.length > 30 ? `${input.substring(0, 30)}...` : input;

    render() {
        var { name, email, affiliate_code, olli_member_id, special_access, email_verified, created_at } = this.state.memberInfo
        var dateTimeRegistered = new Date(created_at).toLocaleString();

        return (
            <div className="container-fluid">
                <AdminNavbar />

                <h1 className='pageTitle'>Detailed Member View</h1>

                <div className='d-flex adminPageSubHeader justify-content-start rounded overflow-hidden mb-4 shadow-sm'>
                    <div className='flex-shrink'>
                        <FaUserCircle size='8em' />
                    </div>
                    <div className='col'>
                        <div>Name: {name}</div>
                        <div>Email: {email} {displayEmailVerified(email_verified)}</div>
                        <div>Affiliate: {displayAffiliateNumber(affiliate_code)}</div>
                        <div>{(special_access === 0) ? 'OLLI Member ID' : 'Special Access Code'}: {olli_member_id}</div>
                        <div>Registered: {dateTimeRegistered}</div>
                    </div>
                </div>


                <table className='table table-striped generalTable rounded overflow-hidden mb-5 shadow-sm'>
                    <thead>
                        <tr>
                            <th className="border-0">Authorized</th>
                            <th className="border-0 d-none d-lg-table-cell">Affiliate</th>
                            <th className="border-0">Device</th>
                            <th className="border-0">IP Address</th>
                            <th className="border-0 d-none d-lg-table-cell">Location</th>
                            <th className="border-0 d-none d-lg-table-cell">Date</th>

                        </tr>
                    </thead>
                    <tbody>
                        {this.state.loginHistory.map((entry, index) => {
                            var entryDateTime = new Date(entry.created_at).toLocaleString();

                            return <tr key={index}>
                                <td className="align-middle">{displayUserAuthAuthorized(entry.authorized)}</td>
                                <td className="align-middle d-none d-lg-table-cell">{displayAffiliateNumber(entry.affiliate_code)}</td>
                                <td className="align-middle">{displayDeviceType(entry.device_type)}</td>
                                <td className="align-middle">{entry.ip_address}</td>
                                <td className="align-middle d-none d-lg-table-cell">{entry.location}</td>
                                <td className="align-middle d-none d-lg-table-cell">{entryDateTime}</td>
                            </tr>
                        })}
                    </tbody>

                </table>

                {
                    this.state.videoHistory.length === 0 ? "" :
                        <React.Fragment>
                            <h1 className='pageTitle'>Videos Watched</h1>

                            <table className='table table-striped generalTable rounded shadow-sm mb-5 overflow-hidden'>
                                <thead>
                                    <tr>
                                        <th className="border-0">Title</th>
                                        <th className="border-0">Partial View</th>
                                        <th className="border-0">Full View</th>
                                        <th className="border-0">Date</th>
                                        <th className="border-0">Rating</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.videoHistory.map((entry, index) => {
                                        var entryDateTime = new Date(entry.created_at).toLocaleString();

                                        return <tr key={index}>
                                            <td className="align-middle">{this.truncate(entry.title)}</td>
                                            <td className="align-middle">{entry.partial_views}</td>
                                            <td className="align-middle">{entry.full_views}</td>
                                            <td className="align-middle">{entryDateTime}</td>
                                            <td className="align-middle">{<FaStar color="orange" textAnchor="0" />}</td>
                                        </tr>
                                    })}
                                </tbody>

                            </table>
                        </React.Fragment>
                }

            </div>
        )
    }
}

export default MemberDetailPage;